import * as S from './ProductSummaryItem.styles'
import SummaryItem from '../../../../SummaryItem/SummaryItem'
import {
  analytics,
  EVENT_NAMES,
} from '../../../../../services/Analytics/Analytics'

type Props = {
  quantity: number
  description: string
  onPlusClick: () => void
  onMinusClick: () => void
  eventProperties: Record<string, unknown>
}

function ProductSummaryItem({
  quantity,
  description,
  onPlusClick,
  onMinusClick,
  eventProperties,
}: Props) {
  const handlePlusClick = () => {
    analytics.track(EVENT_NAMES.CHECKOUT_ITEM_COUNTER_TAPPED, {
      'Previous Count': quantity,
      'New Count': quantity + 1,
      Action: 'Added',
      ...eventProperties,
    })
    onPlusClick()
  }

  const handleMinusClick = () => {
    analytics.track(EVENT_NAMES.CHECKOUT_ITEM_COUNTER_TAPPED, {
      'Previous Count': quantity,
      'New Count': quantity - 1,
      Action: 'Subtracted',
      ...eventProperties,
    })
    onMinusClick()
  }

  return (
    <SummaryItem
      testId="product-summary-item"
      text={`${quantity} ${description}`}
    >
      <S.Controls>
        <S.Control
          $direction="left"
          onClick={handleMinusClick}
          $disabled={quantity <= 1}
        >
          <S.Minus data-testid="subtract-book-button" />
        </S.Control>
        <S.Control $direction="right" onClick={handlePlusClick}>
          <S.Plus data-testid="add-book-button" />
        </S.Control>
      </S.Controls>
    </SummaryItem>
  )
}

export default ProductSummaryItem
